(() => {
  const showHeading = (heading) => {
    heading.classList.add('visible');
    const lines = heading.querySelectorAll('.line');
    lines.forEach((line, lineIndex) => {
      line.classList.remove('animated');
      line.style.overflow = 'hidden';
      Array.from(line.children).forEach((word) => {
        word.style.animationDelay = `${0.8 + lineIndex * 0.25}s`;
        word.style.opacity = '';
        word.style.transform = '';
      });
      requestAnimationFrame(() => line.classList.add('animated'));
      setTimeout(() => { line.style.overflow = 'visible'; }, 1500 + lineIndex * 250);
    });
    setTimeout(() => {
      heading.querySelectorAll('.word').forEach((word) => {
        word.style.opacity = '1';
        word.style.transform = 'none';
      });
    }, 1800);
  };

  const prepareHeadings = (section) => {
    section.querySelectorAll('.js-split-text').forEach((heading) => {
      heading.classList.add('visible');
      if (typeof SplitType !== 'undefined' && !heading.querySelector('.word')) new SplitType(heading, { types: 'lines, words' });
    });
  };

  const initSection = (section) => {
    if (!section?.classList.contains('slideshow-section')) return;
    const box = section.querySelector('.slideshow');
    const slider = section.querySelector('.slideshow__swiper');
    if (!box || !slider || typeof Swiper === 'undefined') return;
    if (slider.swiper) slider.swiper.destroy(true, true);

    prepareHeadings(section);
    const slideCount = Number(box.dataset.slideCount || 0);
    const autoplay = box.dataset.autoplay === 'true' && slideCount > 1;
    const delay = Number(box.dataset.delay || 3) * 1000;
    const speed = Number(box.dataset.speed || 1) * 1000;
    const mobile = Number(box.dataset.slidesMobile || 1);
    const desktop = Number(box.dataset.slidesDesktop || 1);
    const spaceMobile = Number(box.dataset.spaceMobile || 0);
    const spaceDesktop = Number(box.dataset.spaceDesktop || 0);
    document.documentElement.style.setProperty('--bullet-duration', `${delay + speed}ms`);

    const swiper = new Swiper(slider, {
      speed,
      effect: box.dataset.effect || 'slide',
      loop: box.dataset.loop === 'true' && slideCount > 1,
      parallax: box.dataset.parallax === 'true',
      autoHeight: false,
      keyboard: true,
      slidesPerView: mobile,
      spaceBetween: spaceMobile,
      autoplay: autoplay ? { delay, pauseOnMouseEnter: box.dataset.stopAutoplay === 'true', disableOnInteraction: false } : false,
      breakpoints: { 1100: { slidesPerView: desktop, spaceBetween: spaceDesktop } },
      navigation: { nextEl: section.querySelector('.swiper-button-next'), prevEl: section.querySelector('.swiper-button-prev') },
      pagination: { el: section.querySelector('.swiper-pagination'), clickable: true },
      on: {
        init(instance) { const heading = instance.slides[instance.activeIndex]?.querySelector('.js-split-text'); if (heading) showHeading(heading); },
        slideChange(instance) { const heading = instance.slides[instance.activeIndex]?.querySelector('.js-split-text'); if (heading) showHeading(heading); if (typeof initButtonsAnimation === 'function') initButtonsAnimation(instance.slides[instance.activeIndex]); }
      }
    });
    requestAnimationFrame(() => swiper.update());
  };

  const initAll = () => document.querySelectorAll('.slideshow-section').forEach(initSection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initSection(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('.slideshow-section');
    const slide = event.target.closest('.swiper-slide');
    if (section && slide) section.querySelector('.slideshow__swiper')?.swiper?.slideTo([...slide.parentElement.children].indexOf(slide));
  });
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelector('.slideshow__swiper')?.swiper?.destroy(true, true));
})();
